import React, { useEffect, useState } from 'react'
import { useActivate } from 'react-activation'
import BasicForm from './BasicForm'
import ShipmentListTable from './ShipmentListTable'
import SelectStores from '../../components/SelectStores'
import Selector from '../../components/Selector'
import { DatePicker, Select } from 'antd'
import service from '../../../../@services'
import * as Utils from '../../../../@utils'
import BatchUpload from './BatchUpload'
import ShipNoModal from './ShipNoModal'
import ShipFixModal from './ShipFixModal'
import PopupDetail from '../../components/PopupDetail'

const { RangePicker } = DatePicker
const ShipmentPage = props => {
  const { type, activeKey, rootProps } = props
  const [defaultValue, setDefaultValue] = useState({})
  const [init, setInit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [modalVisible, setModalVisible] = useState(false)
  const [fixVisible, setFixVisible] = useState(false)
  const [detailVisible, setDetailVisible] = useState(false)
  const [orderDetail, setOrderDetail] = useState({})
  const [record, setRecord] = useState({})
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({
    pageIndex: 1,
    pageSize: 20
  })
  /** 初始化渲染门店选择框 */
  const setDefault = values => {
    setDefaultValue({ storeCode: [values], receiveWay: '快递配送' })
    if (init) return
    setInit(true)
    setFormData({
      ...formData,
      storeCode: [values],
      orderStatus:
        type == '1' ? ['grouped', 'wait_delivery'] : ['wait_take', 'finish']
    })
  }
  /** 表单筛选项字段及组件 */
  const fields = [
    {
      label: '所属门店',
      name: 'storeCode',
      component: <SelectStores onOptionLoad={setDefault} />
    },
    {
      label: '订单来源',
      name: 'chan',
      component: (
        <Select
          style={{ textAlign: 'left', width: '200px' }}
          placeholder='全部'
          showSearch
          mode='multiple'
          allowClear>
          <Select.Option key='tc_online' value='tc_online'>
            线上
          </Select.Option>
        </Select>
      )
    },
    {
      label: '订单类型',
      name: 'orderTypes',
      width: '250px',
      component: (
        <Selector tag='orderType' filter='1' style={{ width: '220px' }} />
      )
    },
    {
      label: '商品信息',
      name: 'productQueryKey',
      placeholder: '名称/条码/编码'
    },
    { label: '订单编号', name: 'orderNo' },
    {
      label: '下单时间',
      name: 'aftersaleTime',
      component: (
        <RangePicker allowClear placeholder={['开始日期', '结束日期']} />
      )
    },
    { label: '购买人姓名', name: 'buyerName' },
    { label: '购买人电话', name: 'buyerPhone' },
    { label: '收货人姓名', name: 'receiverName' },
    { label: '收货人电话', name: 'receiverPhone' }
  ]
  const getOrderList = () => {
    console.log('getOrderList')
    setLoading(true)
    service.delivery
      .deliveryList({ ...formData })
      .then(res => {
        console.log(res)
        const { result = [], recordCount = 0 } = res
        setDataSource(result)
        setTotal(recordCount)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  // 处理数据
  const formatData = values => {
    if (!values) return {}
    values.afterOrderTime = values.aftersaleTime
      ? values.aftersaleTime[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
      : null
    values.beforeOrderTime = values.aftersaleTime
      ? values.aftersaleTime[1].endOf('day').format('YYYY-MM-DD HH:mm:ss')
      : null
    return { ...values }
  }
  /** 查询 */
  const onSearch = values => {
    let formatValues = formatData(values)
    setFormData({ ...formData, ...formatValues })
  }
  /** 导出 */
  const onExport = async values => {
    let formatValues = formatData(values)
    setFormData({ ...formData, ...formatValues })
    let file = await service.delivery.exportOrderDelivery({
      ...formData,
      ...formatValues
    })
    const filename =
      '订单发货单报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  }
  // 操作事件
  const optionsHandler = (record, type) => {
    if (type === 'shipments') {
      // setModalVisible(true)
      // setRecord(record)
      rootProps.history.push(`/order-delivery/send?orderNo=${record.orderNo}&deliveryWay=${record.deliveryWay}`);
    } else if (type === 'edit') {
      setFixVisible(true)
      setRecord(record)
    } else if (type === 'detail') {
      // setOrderDetail({ ...record, isDelivery: true })
      // setDetailVisible(true)
      rootProps.history.push(
        `/order-delivery/detail?orderNo=${record.orderNo}&orderStatus=${record.orderStatus}&isDelivery=${true}`)
    }
  }
  // 批量导入
  const onUpload = () => {
    console.log('onUpload')
    setVisible(true)
  }
  const onChangePage = ({ pageIndex, pageSize }) => {
    setFormData({
      ...formData,
      pageIndex: pageIndex,
      pageSize: pageSize
    })
  }
  const onUpdate = type => {
    if (type == 'delivery') {
      setModalVisible(false)
    } else if (type == 'fix') {
      setFixVisible(false)
    }
    getOrderList()
  }
  useEffect(() => {
    init && getOrderList()
  }, [init, formData])
  useEffect(() => {
    init && activeKey == type && getOrderList()
  }, [activeKey])

  // 从发货页返回时自动刷新列表
  useActivate(() => {
    if (sessionStorage.getItem('delivery_refresh')) {
      sessionStorage.removeItem('delivery_refresh')
      init && getOrderList()
    }
  })
  return (
    <div>
      <BasicForm
        name='shipmentPage'
        fields={fields}
        onSearch={onSearch}
        onExport={onExport}
        onUpload={onUpload}
        type={type}
        defaultValue={defaultValue}
        authKey={{
          search: '/order-delivery/list',
          export: '/order-delivery/export'
        }}
      />
      <ShipmentListTable
        type={type}
        total={total}
        dataSource={dataSource}
        loading={loading}
        page={formData}
        optionsHandler={optionsHandler}
        onChange={onChangePage}
      />
      <BatchUpload
        visible={visible}
        storeCode={formData.storeCode}
        close={() => {
          setVisible(false)
        }}
      />
      <ShipNoModal
        visible={modalVisible}
        storeCode={formData.storeCode}
        record={record}
        close={() => {
          setModalVisible(false)
        }}
        update={onUpdate}
      />
      <ShipFixModal
        visible={fixVisible}
        storeCode={formData.storeCode}
        record={record}
        close={() => {
          setFixVisible(false)
        }}
        update={onUpdate}
      />
      <PopupDetail
        visible={detailVisible}
        onClose={() => setDetailVisible(false)}
        detail={orderDetail}
      />
    </div>
  )
}
export default ShipmentPage
